import Header from '../src/components/Header'
import Hero from '../src/components/Hero'
import Menu from '../src/components/Menu'
import Footer from '../src/components/Footer'
import DrinksMenu from '../src/components/DrinksMenu'
import Info from '../src/components/Info'
import AllergensTxt from '../src/components/AllergensTxt'
import React, { useState, useEffect,useRef } from 'react'
import { groqFetch } from './services/groqFetch'
import useScrollPosition from '@react-hook/window-scroll'

function App() {
  const scrollYProgress = useScrollPosition(60 /*fps*/)
    const ref = useRef(null)
    const [isEng, setIsEng] = useState(false)
    const [isFood, setIsFood] = useState(true)
    const [categories, setCategories] = useState(null)
    const [products, setProducts] = useState(null)
    const [selectedCat, setSelectedCat] = useState('')
    const [drinkCategories, setDrinkCategories] = useState(null)
    const [drinkProducts, setDrinkProducts] = useState(null)
    const [selectedDrinkCat, setSelectedDrinkCat] = useState('')
    const [showInfo, setShowInfo] = useState(false)
    const [showAllergens, setshowAllergens] = useState(false)
    const [highlights, setHighlights] = useState(null)
    const [info, setInfo] = useState(null)
    
    
    
   
    
    useEffect(() => {
     groqFetch().then((data)=>{
        
          let cats = []  
          let prods = []
          let drinkCats = []
          let drinkProds = []
          let info = []
          let highlights = []
          for(let x of data){
            if(x.type === 'category'){
              cats.push(x)
            }else if(x.type === 'product' || x.type === 'lunchMenuProduct'){
              prods.push(x)
            }else if(x.type === 'drinksCategory'){
              drinkCats.push(x)
            }else if(x.type === 'drinksProduct'){
              drinkProds.push(x)
            }else if(x.type === 'info'){
              info.push(x)
            }else if(x.type === 'highlights'){
              highlights.push(x)
            }
          }
          
          cats = cats.sort((a,b) => a.importance - b.importance)
          drinkCats = drinkCats.sort((a,b)=> a.importance - b.importance)
         
          setCategories(cats)
          setDrinkCategories(drinkCats)
          setProducts(prods)
          setDrinkProducts(drinkProds)
          setInfo(info)
          setHighlights(highlights)
          setSelectedCat(cats[1].title)
          setSelectedDrinkCat(drinkCats[0].title)
          setshowAllergens(false)
         
        })},[])
    
    
    function isFoodSetter(bool){
      setIsFood(bool)
    }
    const handleRefClick = () => {      
      ref.current?.scrollIntoView({behavior: 'smooth'});
    };
    const handleShowInfoClick = () =>{
      if(showAllergens === true){
        setshowAllergens(!showAllergens)
      }
      setShowInfo(!showInfo)
    }
    function handleShowAllergensClick(){
      if(showInfo === true){
        setShowInfo(!showInfo)
      }
      setshowAllergens(!showAllergens)
      
    }
    

  return (
    <div className='relative overflow-hidden cursive text-xl bg-beigeOne'>
      <div ref={ref}></div>
      {info && <Header info={info} showAllergens={showAllergens}  isEng={isEng} setIsEng={setIsEng} 
      handleShowInfoClick={handleShowInfoClick} handleShowAllergensClick={handleShowAllergensClick}  />   }
      {info && 
      <Info isEng={isEng} info={info} showInfo={showInfo} />  
      }
      {showAllergens && <AllergensTxt handleShowAllergensClick={handleShowAllergensClick} showAllergens={showAllergens}></AllergensTxt>}
       <Hero isEng={isEng} highlights={highlights} isFood={isFood} />
       {isFood ? 
       <Menu isEng={isEng} isFood={isFood} categories={categories} products={products} selectedCat={selectedCat} setSelectedCat={setSelectedCat} />
       : <DrinksMenu 
       isEng={isEng} isFood={isFood} categories={drinkCategories} 
       products={drinkProducts} selectedCat={selectedDrinkCat} setSelectedCat={setSelectedDrinkCat} />}

      <Footer 
      isEng={isEng} setIsEng={setIsEng} scrollYProgress={scrollYProgress}  handleShowInfoClick={handleShowInfoClick}
      handleRefClick={handleRefClick}  isFood={isFood} isFoodSetter={isFoodSetter} />
    </div>
  );
}

export default App;
